import { render, staticRenderFns } from "./CheckboxGroupWidget.vue?vue&type=template&id=9761bc5e&"
import script from "./CheckboxGroupWidget.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroupWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports